import { TKV2_ORDER_PAIRED_COST_SETTINGS_API } from '@aloft/toolkit-shared';

import { useEffect } from 'react';

import { usePutTkv2OrderPairedCostSettingsAPI } from '../../hooks/api/schema-hooks/usePutTkv2OrderPairedCostSettingsAPI.ts';
import { useEdgeTrigger } from '../../hooks/useEdgeTrigger.ts';
import { adjustmentSettingsMutationComplete } from '../../redux/features/orderSlice.ts';
import { useAppDispatch, useAppSelector } from '../../redux/hooks.ts';
import { DEFAULT_SYNC_DRIVER_DELAY_MS } from './consts.ts';

export function useAdjustmentSettingsSyncDriver(orderID: string) {
  const dispatch = useAppDispatch();
  const { mutate: adjustmentSettingsMutate } = usePutTkv2OrderPairedCostSettingsAPI();
  const adjustmentSettings = useAppSelector((state) => state.order.adjustmentSettings);
  const {
    editRevision = 0,
    serverRevision = 0,
    saveAsDefault,
  } = useAppSelector((state) => state.order.adjustmentSettingsSync) ?? {};

  const onSuccess = () => {
    dispatch(
      adjustmentSettingsMutationComplete({
        status: 'success',
        serverRevision: editRevision,
      }),
    );
  };

  const onError = () => {
    dispatch(
      adjustmentSettingsMutationComplete({
        status: 'error',
      }),
    );
  };

  const mutate = () => {
    adjustmentSettingsMutate(
      {
        pathParams: { orderID },
        body: TKV2_ORDER_PAIRED_COST_SETTINGS_API.PUT.REQUEST.BODY.parse(adjustmentSettings),
        queryParams: TKV2_ORDER_PAIRED_COST_SETTINGS_API.PUT.REQUEST.QUERY_PARAMS.parse({
          saveAsDefault: saveAsDefault?.toString(),
        }),
      },
      { onSuccess, onError },
    );
  };

  const mutationTrigger = useEdgeTrigger({
    condition: editRevision > serverRevision,
    delayMs: DEFAULT_SYNC_DRIVER_DELAY_MS,
    action: mutate,
  });

  useEffect(() => {
    mutationTrigger.restartTimer();
  }, [editRevision, mutationTrigger]);
}
